import {useShowUI} from "../../services/common";

const MainContent = (props) => (<div className={useShowUI() ? 'main' : null} {...props} />);

export default MainContent;
